import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'app-file-too-large-warning-dialog',
	templateUrl: './file-too-large-warning-dialog.component.html',
	styleUrls: ['./file-too-large-warning-dialog.component.css']
})
export class FileTooLargeWarningDialogComponent implements OnInit {

	// Properties
	message = 'The file is too large. Choose a smaller file or reduce the file&apos;s size.';
	// Class Functions
	constructor(
		private dialogBox: MatDialogRef<FileTooLargeWarningDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
	) { }

	// Event Functions
	ngOnInit() {
		if (this.data.maxFileSizeMessage && this.data.maxFileSizeMessage.length > 0) {
			this.message = this.data.maxFileSizeMessage;
		}

	}

	close() {
		// PRE: the close button is clicked
		// POST: closes the dialog box
		this.dialogBox.close();
	}

	// Methods
}
